<template>
  <Row class="row-item" :gutter="12">
    <Col span="4" class="col-item">
      <span class="item-field">{{ description }}({{ len }}/{{ max }})</span>
    </Col>
    <Col span="20">
      <div
        class="c-style-item"
        :class="{ 'm-check': style.check, 'm-disabled': len === max && !style.check }"
        v-for="(style, id) in smartData"
        :key="style.sticker_style_id"
        @click="$emit('on-select', id)"
      >
        <img :src="style.sticker_styles_url" alt="" />
        <Icon type="md-checkbox" size="28" color="#2b85e4" v-if="style.check" />
      </div>
    </Col>
  </Row>
</template>
<script>
import { isArray, deepCopy } from '@/common/js/utils'
export default {
  name: 'smartSticker',
  props: {
    data: {
      type: Array
    },
    max: {
      type: Number,
      default: 6
    },
    description: {
      type: String,
      default: ''
    },
    sceneId: {
      type: Number,
      default: 1
    },
    verify: {
      type: Boolean
    }
  },
  computed: {
    len() {
      return this.data.filter((ret) => ret.check).length
    },
    smartData() {
      return this.data.map((ret) => {
        const sticker_styles = deepCopy(ret.sticker_styles)
        if (isArray(sticker_styles)) {
          sticker_styles.shift()
          ret.sticker_styles_url = sticker_styles.shift().overlay_preview_url
        } else ret.sticker_styles_url = ''
        return ret
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.c-style-item {
  position: relative;
  width: 98px;
  height: 98px;
  display: inline-block;
  vertical-align: top;
  overflow: hidden;
  margin: 8px 8px 0 0;
  border: 4px solid #fff;
  border-radius: 3px;

  img {
    width: 100%;
    margin-top: -10px;
  }

  .ivu-icon {
    position: absolute;
    right: 0;
    top: 4px;
  }

  &.m-disabled {
    border-color: #ebebeb;

    &:before {
      content: '';
      width: 98px;
      height: 98px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      background-color: rgba(150, 150, 150, 0.7);
    }
  }

  &.m-check {
    border-color: #2b85e4;
  }
}

.row-item {
  align-items: flex-start;

  span.item-field {
    height: 32px;
    line-height: 32px;
  }
}
</style>
